// extracted by mini-css-extract-plugin
module.exports = {"settingsOverrideContainer":"CrmIntegrationView_settingsOverrideContainer__1H4xv"};